import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Typography,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
  hint: {
    border: `10px solid ${grey[100]}`,
    overflow: "auto",
    background: "#fff",
  },
  videoWrapper: {
    background: "#fff",
    boxSizing: "border-box",
    width: "100%",
    height: 0,
    paddingBottom: "56.25%",
    position: "relative",
  },
  yt: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
  },
}));

const Video = ({ yt = null }) => {
  const classes = useStyles();
  const [privacyChecked, setPrivacyChecked] = useState(false);

  useEffect(() => {
    const privacy = localStorage.getItem("privacy");
    if (privacy === "accepted") {
      setPrivacyChecked(true);
    }
  }, []);

  const handleChange = (event) => {
    if (event.target.checked) {
      localStorage.setItem("privacy", "accepted");
      setPrivacyChecked(true);
      return;
    }
    localStorage.removeItem("privacy");
    setPrivacyChecked(false);
  };

  if (!yt) {
    return null;
  }

  const privacyHint = (
    <Box p={2} height="100%" className={classes.hint}>
      <Typography variant="h3" gutterBottom>
        Hinweis
      </Typography>
      <Typography variant="body2">
        An dieser Stelle findest du einen externen Inhalt von <strong>YouTube</strong>. Du kannst dir hier alle
        externen Inhalte mit einem Klick anzeigen lassen oder wieder ausblenden
      </Typography>
      <Box py={4}>
        <FormControlLabel
          control={
            <Switch
              checked={privacyChecked}
              onChange={handleChange}
              name="privacy"
            />
          }
          label={<strong>YouTube Videos anzeigen</strong>}
        />
      </Box>
      <Typography variant="body2" color="textSecondary">
        Ich bin damit einverstanden, dass mir externe Inhalte angezeigt werden.
        Damit können personenbezogene Daten an Drittplattformen übermittelt
        werden. Weitere Informationen in unserer{" "}
        <a
          href="http://www.asgkl.de/datenschutz/"
          target="_blank"
          rel="noreferrer"
        >
          Datenschutzerklärung
        </a>
      </Typography>
    </Box>
  );

  const video = (
    <>
      <div className={classes.videoWrapper}>
        <iframe
          className={classes.yt}
          frameBorder="0"
          allowFullScreen="1"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          src={
            yt
              .replace("https://youtu.be/", "https://www.youtube.com/embed/")
              .replace(/\s/g, "") + "?rel=0"
          }
          title="YouTube video player"
        ></iframe>
      </div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        bgcolor="rgba(0,0,0,0.4)"
        color="#fff"
      >
        <FormControlLabel
          control={
            <Switch
              checked={privacyChecked}
              onChange={handleChange}
              name="privacy"
            />
          }
          label="Externe Inhalte"
        />
        <a
          href="http://www.asgkl.de/datenschutz/"
          target="_blank"
          rel="noreferrer"
          style={{color: "#fff"}}
        >
          Datenschutzerklärung
        </a>
      </Box>
    </>
  );

  return <>{privacyChecked ? video : privacyHint}</>;
};

export default Video;
